(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["olaya-grid-colores"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__olayaGridColores) return;
    window.__olayaGridColores = true;

    function colocar() {
      document.querySelectorAll('.product-grid-item [data-on-gs]:not([data-on-gs-ok])').forEach(function (s) {
        s.setAttribute('data-on-gs-ok', '1');
        var a = s.closest('a');
        if (a && a.parentNode) a.parentNode.insertBefore(s, a.nextSibling);
      });
    }

    function elegir(item) {
      var card = item.closest('.product-grid-item');
      if (!card) return;
      var img = card.querySelector('[data-product-media-featured] img') || card.querySelector('.product__media__image img');
      if (img) {
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.src = item.getAttribute('data-img');
      }
      card.classList.add('on-gs-sel');
      card.querySelectorAll('.on-gs__item').forEach(function (i) { i.classList.toggle('is-active', i === item); });
      var url = item.getAttribute('data-url');
      var id = item.getAttribute('data-variant');
      card.querySelectorAll('a[data-grid-link]').forEach(function (a) {
        try {
          if (url) { a.setAttribute('href', url); return; }
          if (id) {
            var u = new URL(a.getAttribute('href'), location.href);
            u.searchParams.set('variant', id);
            a.setAttribute('href', u.pathname + u.search);
          }
        } catch (e) {}
      });
    }

    document.addEventListener('click', function (e) {
      var item = e.target.closest && e.target.closest('.on-gs__item');
      if (!item) return;
      e.preventDefault();
      e.stopPropagation();
      elegir(item);
    }, true);

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var item = e.target.closest && e.target.closest('.on-gs__item');
      if (!item) return;
      e.preventDefault();
      elegir(item);
    });

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', colocar); else colocar();
    new MutationObserver(colocar).observe(document.documentElement, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
